import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmPurposeForm from '../../../components/forms/FirearmPurposeForm';
import { useCreateFirearmPurpose } from '../../../hooks/useFirearmPurposeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmPurposeDTO } from '../../../services/apiClient';

const FirearmPurposeCreate: React.FC = () => {
  const createFirearmPurpose = useCreateFirearmPurpose();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Purposes', href: '/admin/firearmpurposes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmPurposeDTO) => {
    try {
      await createFirearmPurpose.mutateAsync(data);
      navigate('/admin/firearmpurposes');
    } catch (error) {
      console.error('Error creating FirearmPurpose:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmpurposes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmPurpose.Edit'
    >
        <FirearmPurposeForm
          initialValues={{} as FirearmPurposeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmpurposes')}
        />
    </AdminLayout>
  );
};

export default FirearmPurposeCreate;